import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Row, Col, ListGroup, Card } from 'react-bootstrap';
import { useGetHouseDetailsQuery } from '../slices/housesApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Meta from '../components/Meta';
import HouseCarousel from '../components/HouseCarousel';

const HouseScreen = () => {
  const { id: houseId } = useParams();
  const { data: house, isLoading, error } = useGetHouseDetailsQuery(houseId);

  const renderHouseDetails = () => (
    <>
      <Meta title={house.name} description={house.address} />
      <Row>
        <Col md={6}>
          {/* Display house images using HouseCarousel */}
          {house.images && house.images.length > 0 ? (
            <HouseCarousel images={house.images} />
          ) : (
            <Message variant="info">No images available for this house</Message>
          )}
        </Col>
        <Col md={3}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3>{house.name}</h3>
            </ListGroup.Item>
            <ListGroup.Item>Type: {house.type}</ListGroup.Item>
            <ListGroup.Item>Address: {house.address}</ListGroup.Item>
            <ListGroup.Item>
              Bedrooms: {house.bedrooms}, Bathrooms: {house.bathrooms}
            </ListGroup.Item>
            <ListGroup.Item>Price: D{house.regularPrice}</ListGroup.Item>
            <ListGroup.Item>Measurement:{house.size}</ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <Row>
                  <Col>Price:</Col>
                  <Col>
                    <strong>D{house.regularPrice}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status:</Col>
                  <Col>
                    {house.availability ? 'Available' : 'Unavailable'}
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
          <div className="house-images mt-3">
                    <h6>Images:</h6>
                    <div className="image-thumbnails">
                      {house.images?.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={` ${index + 1}`}
                          className="thumbnail-img"
                          style={{
                            width: '50px',
                            height: '50px',
                            marginRight: '5px',
                            borderRadius: '5px',
                          }}
                        />
                      ))}
                    </div>
                  </div>
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <Link className="btn btn-light my-3" to="/">
        Go Back
      </Link>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        renderHouseDetails()
      )}
    </>
  );
};

export default HouseScreen;